const arrayAnyTrue = (array: boolean[]): boolean =>
  array.some((element) => element)

export default arrayAnyTrue
